import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAdminSignupsApi } from '../api';
import { AdminSignup } from '../types';

export const useAdminSignupViewController = () => {
  const { signupId } = useParams<{ signupId: string }>();
  const api = useAdminSignupsApi();

  const [signup, setSignup] = useState<AdminSignup | null>(null);
  const [isLoading, setLoading] = useState(true);
  // Told apart from "still loading" on purpose: the id comes from a Slack alert and can outlive its funnel,
  // and a blank screen is the one answer that leaves the reader guessing which of the two happened.
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (signupId == null) {
      setLoading(false);
      setNotFound(true);
      return;
    }

    let current = true;
    setLoading(true);
    api
      .getSignup(signupId)
      .then(({ data }) => {
        if (!current) return;
        setSignup(data);
        setNotFound(false);
      })
      .catch(() => {
        if (!current) return;
        setSignup(null);
        setNotFound(true);
      })
      .finally(() => {
        if (current) setLoading(false);
      });

    return () => {
      current = false;
    };
  }, [api, signupId]);

  return { signupId, signup, isLoading, notFound };
};
